import { render, staticRenderFns } from "./PhoneNumberVerificationCode.vue?vue&type=template&id=18d855f9&"
import script from "./PhoneNumberVerificationCode.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberVerificationCode.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberVerificationCode.vue?vue&type=style&index=0&id=18d855f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports